/* LZ Gift Picker controller — Tu B'Av free gift (₪999+).
   Delegated + persistent: survives cart-drawer re-renders. Adds/switches the chosen Howlite variant
   (native BXGY zeroes it) and auto-removes the gift if the cart drops below the threshold. */
(function () {
  var THRESHOLD = 99900;
  var busy = false;
  var root = function () { return document.querySelector('.lz-gift'); };
  var giftIds = function () {
    var el = root();
    return el ? (el.dataset.giftIds || '').split(',').filter(Boolean).map(Number) : [];
  };
  var post = function (url, body) {
    return fetch(Shopify.routes.root + url, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    });
  };
  var getCart = function () { return fetch(Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }); };
  var refresh = function () { document.dispatchEvent(new CustomEvent('cart:refresh')); };

  function removeGiftFrom(cart) {
    var ids = giftIds(), updates = {}, found = false;
    cart.items.forEach(function (it) { if (ids.indexOf(it.variant_id) > -1) { updates[it.variant_id] = 0; found = true; } });
    if (!found) return Promise.resolve(false);
    return post('cart/update.js', { updates: updates }).then(function () { return true; });
  }

  function addGift(variantId) {
    if (busy) return;
    busy = true;
    getCart()
      .then(function (cart) { return removeGiftFrom(cart); })
      .then(function () { return post('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] }); })
      .catch(function () {})
      .then(function () { busy = false; refresh(); });
  }

  // Guard: gift present but cart fell below threshold -> remove it so it isn't charged.
  function enforce() {
    if (busy) return;
    var ids = giftIds();
    if (!ids.length) return;
    getCart().then(function (cart) {
      var qualifying = 0, hasGift = false;
      cart.items.forEach(function (it) {
        if (ids.indexOf(it.variant_id) > -1) hasGift = true; else qualifying += it.final_line_price;
      });
      if (hasGift && qualifying < THRESHOLD) {
        busy = true;
        removeGiftFrom(cart).then(function () { busy = false; refresh(); });
      }
    });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('.lz-gift__add');
    if (add) {
      e.preventDefault();
      var sel = add.closest('.lz-gift__opt').querySelector('.lz-gift__size');
      if (sel && sel.value) addGift(sel.value);
      return;
    }
    var sw = e.target.closest && e.target.closest('.lz-gift__switch');
    if (sw) {
      e.preventDefault();
      var opts = root() && root().querySelector('.lz-gift__options');
      if (opts) opts.hidden = !opts.hidden;
    }
  });

  document.addEventListener('cart-drawer:refreshed', enforce);
  document.addEventListener('cart:change', enforce);
  if (document.readyState !== 'loading') enforce();
  else document.addEventListener('DOMContentLoaded', enforce);
})();
